module.exports = __webpack_public_path__ + "img/signalizator-jedna-faze.ab8cb033.webp";